import { Injectable } from '@angular/core';

import { FormControl, FormGroup } from '@angular/forms';
import { IBBSearchParams, productRequestSortType } from './bulletin-board.interface';
import { parseBoolean } from '../../core/utils/helper';

@Injectable()
export class BulletinBoardFormModel {
  readonly formGroup = new FormGroup({
    only_mine: new FormControl<boolean>(false),
    keyword: new FormControl<string | null>(null),
    ordering: new FormControl<productRequestSortType | null>('-id'),
  });

  getApiQueryParams(params?: Partial<IBBSearchParams>) {
    return {
      only_mine: params?.only_mine ?? false,
      keyword: params?.keyword ?? '',
      ordering: params?.ordering ?? '-id',
      page: params?.page ?? 1,
    };
  }

  setSearchParams(params: Partial<IBBSearchParams>) {
    this.formGroup.patchValue({
      only_mine: parseBoolean(params.only_mine),
      keyword: params.keyword ?? null,
      ordering: params.ordering ?? '-id',
    });
  }
}
